import React from 'react'
import { Spin } from 'antd'

export const CenteredSpinner: React.FC = () => (
  <div style={{ textAlign: 'center', padding: '2em' }}>
    <Spin />
  </div>
)
